/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SVGIcons } from "cms/icons/svg-icons";
import Config from "data/config";
import { PERMISSION } from "cms/auth/hooks/use-RBAC";

const conditionalItems = [];

if (Config.features.Dashboard.Enabled) {
    conditionalItems.push({
        name: "dashboard",
        icon: <SVGIcons.common.LineChart />,
        path: "/dashboard",
        permission: PERMISSION.GENERAL,
        // feature_flag: "feature_dashboard",
    });
}
if (Config.features.Tasks.Enabled) {
    conditionalItems.push({
        name: "tasks",
        icon: <SVGIcons.common.Tasks />,
        path: "/tasks",
        permission: PERMISSION.TASKS,
        // feature_flag: "feature_tasks",
    });
}
if (Config.features.Composer.Enabled) {
    conditionalItems.push({
        name: "composer",
        icon: <SVGIcons.common.Composer />,
        path: "/composer",
        permission: PERMISSION.COMPOSER,
        // feature_flag: "feature_composer",
    });
}
if (Config.features.Websites.Enabled) {
    conditionalItems.push({
        name: "websites",
        icon: <SVGIcons.common.Websites />,
        path: "/websites",
        permission: PERMISSION.WEBSITE,
        // feature_flag: "feature_websites",
    });
}
if (Config.features.Forms.Enabled) {
    conditionalItems.push({
        name: "forms",
        icon: <SVGIcons.common.Forms />,
        path: "/forms",
        permission: PERMISSION.FORMS,
        // feature_flag: "feature_forms",
    });
}
if (Config.features.Digital_Assets.Enabled) {
    conditionalItems.push({
        name: "digital assets",
        icon: <SVGIcons.common.DigitalAssets />,
        path: "/digital-assets",
        permission: PERMISSION.DIGITAL_ASSETS,
        // feature_flag: "feature_digital_assets",
        
        // children: [
        //   {
        //     name: "images",
        //     icon: <SVGIcons.fields.ImageField />,
        //     path: "/images",
        //   },
        //   {
        //     name: "documents",
        //     icon: <SVGIcons.fields.DocumentField />,
        //     path: "/documents",
        //   },
        // ]
    });
}

if (Config.features.Messaging.Enabled) {
    conditionalItems.push({
        name: "messaging",
        icon: <SVGIcons.common.Email />,
        path: "/messaging",
        permission: PERMISSION.NOTIFICATION_ADMIN,
        feature_flag: "feature_messaging"
    });
}

if (Config.features.Models.Enabled) {
    conditionalItems.push({
        name: "modelling",
        icon: <SVGIcons.common.Content />,
        path: "/modelling",
        permission: PERMISSION.NOTIFICATION_ADMIN,
        feature_flag: "feature_modelling"
    });
}

// if (Config.features.Models.Enabled) {
//     conditionalItems.push({
//         name: "development",
//         icon: <SVGIcons.common.Content />,
//         path: "/development",
//         permission: PERMISSION.MODEL_DESIGN,
//         feature_flag: "feature_development",
//     });
// }

// if (Config.features.Data.Enabled) {
//     conditionalItems.push({
//         name: "data",
//         icon: <SVGIcons.common.Components />,
//         path: "/data",
//         permission: PERMISSION.DATA,
//         // feature_flag: "feature_data",
//     });
// }
// if (Config.features.OrganizationsSettings.Enabled) {
//     conditionalItems.push({
//         name: "organization",
//         icon: <SVGIcons.common.Organization/>,
//         path: "/organization",
//         permission: PERMISSION.ORGANIZATION,
//         // feature_flag: "feature_org_settings",
//     });
// }
// if (Config.features.Testing.Enabled) {
//     conditionalItems.push({
//         name: "testing",
//         icon: <SVGIcons.common.Content/>,
//         path: "/testing",
//         permission: PERMISSION.SIMPLICITY_INTERNAL,
//         // feature_flag: "feature_content",
//     });
// }
// if (Config.features.Components.Enabled) {
//     conditionalItems.push({
//         name: "components",
//         icon: <SVGIcons.common.Components />,
//         path: "/components",
//         permission: PERMISSION.SIMPLICITY_INTERNAL,
//         // feature_flag: "feature_components",
//     });
// }

// {
//   name: "webpages",
//   icon: <SVGIcons.common.Websites />,
//   path: "/website/webpages",
//   permission: 'permission.?',
// },
// {
//     name: 'applications',
//     icon: <SVGIcons.common.Application />,
//     path: '/applications',
//     permission: 'permission.?',
// },
// {
//   name: "content",
//   icon: <SVGIcons.common.Content />,
//   path: "/content/edit",
//   permission: 'permission.?',
// },
// {
//     name: 'components',
//     icon: <SVGIcons.common.Components />,
//     path: '/components',
//     permission: 'permission.?',
// },

const navItems = [
    ...conditionalItems
];
export { navItems };
